<template>
    <b-col tag="li" sm="6">
        <router-link :to="{name: 'object-store'}">
            <svg-assets/>
            <p>Object Store</p>
            <p>Store and serve static assets</p>
        </router-link>
    </b-col>
</template>

<script>
const svgAssets = () => import('@/components/svg/create-button/svg-assets');

export default {
    components: {
        svgAssets
    }
}
</script>
